import { render, staticRenderFns } from "./VNumber.vue?vue&type=template&id=5608b742&scoped=true"
import script from "./VNumber.vue?vue&type=script&lang=js"
export * from "./VNumber.vue?vue&type=script&lang=js"
import style0 from "./VNumber.vue?vue&type=style&index=0&id=5608b742&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5608b742",
  null
  
)

export default component.exports